import React, { ReactElement } from "react";

import { PageMeta } from "@shared/seo/page-meta";
import { AboutPage } from "@widgets/about-page";

export const About: React.FC = (): ReactElement => {
    return (
        <>
            <PageMeta
                title="О Plumme — клубы, события и новые знакомства"
                description="Plumme объединяет людей через закрытые клубы, события и сообщества по интересам в Москве и других городах России."
                path="/about"
            />

            <AboutPage />
        </>
    );
};